// extracted by mini-css-extract-plugin
module.exports = {"container":"TempRegister_container__3UAVx","tab-container":"TempRegister_tab-container__1u0xn"};